import React, { Component } from "react";
import { connect } from "react-redux";
import { FormGroup, ControlLabel } from "react-bootstrap";
import Select from "react-select";
import _ from "lodash";
import "react-select/dist/react-select.css";
import "./index.css";

class ResolutionCategoryDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedResolutionCategory: undefined,
    };
  }

  handleChange = selectedOption => {
    this.setState({ selectedResolutionCategory: selectedOption });
    if (selectedOption) {
      this.props.change(selectedOption);
    } else {
      this.props.change(null);
    }
  };

  filterResolutionCategories = () => {
    const { note_resolution_categories } = this.props.configList;
    return _.filter(note_resolution_categories, "available_for_resolve_multiple");
  };

  render = () => {
    const { selectedResolutionCategory } = this.state;
    const { isBulkResolve, configList, pageType } = this.props;
    let labelTitle = "";
    let resolutionList = null;

    if (pageType !== "createReport") {
      labelTitle = "Resolution Category*";
      resolutionList = configList.note_resolution_categories;
    } else {
      labelTitle = "Note resolution type";
      resolutionList = configList.compliance_summary_report_note_resolution_categories;
    }

    return (
      <div className="resolution-category-dropdown">
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>{labelTitle}</ControlLabel>
          <Select
            name="form-field-name"
            value={selectedResolutionCategory}
            onChange={this.handleChange}
            valueKey="id"
            labelKey="display_name"
            multi={pageType === "createReport" ? true : false}
            options={isBulkResolve ? this.filterResolutionCategories() : resolutionList}
          />
        </FormGroup>
      </div>
    );
  };
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  const { configList } = state.configuration;
  return {
    user,
    configList
  };
}

export default connect(mapStateToProps)(ResolutionCategoryDropdown);



// WEBPACK FOOTER //
// ./src/_components/ResolutionCategoryDropdown/index.js